import { API_KEYS } from "constants/apiEndpoints";
import { REDUX_ACTIONS } from "constants/constants";
import { requestPostFetchApi } from "utils/apiMethods";
import {
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";

export const requestClientDetails = () => {
  return async (dispatch) => {
    requestPostFetchApi(API_KEYS.CLIENT_DETAILS, {
      uuid: getVendingMachineUuid(),
    }).then(
      (response) => {
        dispatch(dispatchCLdetails(response));
      },
      (error) => {
        dispatch({ type: REDUX_ACTIONS.DUMMY_ACTION });
      }
    );
  };
};

const dispatchCLdetails = (data) => {
  return {
    type: REDUX_ACTIONS.FETCH_CL_DETAILS,
    payload: data,
  };
};

export const resetCLdetails = () => {
  return {
    type: REDUX_ACTIONS.RESET_CL_DETAILS,
  };
};
